// TOP LEVEL IMPORTS
import React from 'react';
// STRIPE
import PaymentFormContainer from './PaymentFormContainer';
import Bottom from './Bottom';
import PaymentSuccessful from './PaymentSuccessful';
import PaypalPayBtn from './PaypalPayBtn';
// ANT
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import Title from 'components/text/Title';

const Top = () => (
  <div style={{ textAlign: 'center', marginBottom: 15, color: '#888' }}>
    <Title>Credit/Debit Card</Title>
  </div>
);

const PaymentFormArea = ({ invoice, currencySymbol }) => {
  if (invoice && invoice.status === 'PAID') {
    return <PaymentSuccessful />;
  }

  return (
    <div style={{ minHeight: 100 }}>
      <Row gutter={25}>
        <Col xs={24}>
          {invoice.organization && invoice.organization.stripeUserIdExists && invoice.organization.stripeUserIdExists && (
            <div>
              <Top />
              <PaymentFormContainer invoice={invoice} currencySymbol={currencySymbol} />
              <Bottom />
            </div>
          )}
        </Col>
        {invoice.owner &&
          invoice.owner.paypalEmail &&
          invoice.organization &&
          invoice.organization.stripeUserIdExists &&
          invoice.organization.stripeUserIdExists && (
            <Col xs={24} style={{ padding: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
              <h1 className="center">OR</h1>
            </Col>
          )}
        {invoice.owner && invoice.owner.paypalEmail && (
          <Col
            xs={24}
            className="center"
            style={{ padding: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}
          >
            {console.log(invoice.owner.paypalEmail)}
            <PaypalPayBtn
              payeeEmail={invoice.owner.paypalEmail}
              invoice={invoice}
              amount={invoice.finalPaymentAmount / 100} // must pass in decimals
              currency={invoice.currency || 'USD'}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PaymentFormArea;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/index.js